import { render, staticRenderFns } from "./AdminReportsCustomerWeekly.vue?vue&type=template&id=35c1c028&scoped=true&"
import script from "./AdminReportsCustomerWeekly.vue?vue&type=script&lang=js&"
export * from "./AdminReportsCustomerWeekly.vue?vue&type=script&lang=js&"
import style0 from "./AdminReportsCustomerWeekly.vue?vue&type=style&index=0&id=35c1c028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c1c028",
  null
  
)

export default component.exports